var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlGreenFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.668 18.5418C14.9504 18.4222 14.3523 18.9006 14.3523 19.6182L12.4387 33.4921H4.3057L2.39206 19.6182C2.27245 19.0202 1.67444 18.5418 1.07643 18.5418C0.478411 18.6614 0 19.2594 0 19.8574L2.03325 34.8077C2.15285 35.4058 2.63126 35.8842 3.22928 35.8842H13.3955C13.9935 35.8842 14.4719 35.4058 14.5915 34.8077L16.6248 19.8574C16.864 19.2594 16.3856 18.6614 15.668 18.5418Z",
    fill: "#2D5E59"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4121 8.97021C23.9238 8.97021 25.957 6.93696 25.957 4.4253C25.957 1.91365 23.9238 0 21.4121 0C18.9004 0 16.8672 2.03325 16.8672 4.54491C16.8672 7.05657 19.02 8.97021 21.4121 8.97021Z",
    fill: "#2D5E59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5334 27.3863C7.7726 27.6255 8.01181 27.7451 8.37062 27.7451C8.72943 27.7451 8.96863 27.6255 9.20784 27.3863L12.4371 24.1571C12.9155 23.6786 12.9155 22.961 12.4371 22.4826L9.20784 19.2533C8.72943 18.7749 8.01181 18.7749 7.5334 19.2533L4.30412 22.4826C3.82571 22.961 3.82571 23.6786 4.30412 24.1571L7.5334 27.3863Z",
    fill: "#2D5E59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7818 17.1007L27.5094 11.4793C27.2702 11.1205 26.9114 10.7617 26.433 10.7617H10.765C10.167 10.7617 9.68857 11.1205 9.56896 11.7185C9.44936 12.3166 9.68857 12.795 10.2866 13.0342L16.5059 15.6654L18.3 18.2967V34.6823C18.3 35.1607 18.6588 35.6391 19.1372 35.8783C19.6156 35.9979 20.2136 35.8783 20.4528 35.5195L24.1605 30.7354L27.629 35.5195C27.8682 35.8783 28.227 35.9979 28.5858 35.9979H28.9446C29.423 35.8783 29.7818 35.3999 29.7818 34.8019V17.5791C29.7818 17.3399 29.7818 17.2203 29.7818 17.1007Z",
    fill: "#2D5E59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlGreenFour);
export default __webpack_public_path__ + "static/media/al-green-four.4c682ca3609c668459bb6ae06fa67e31.svg";
export { ForwardRef as ReactComponent };